export const APP_CONSTANTS = {
  // Fee Calculation
  BASE_FEE: 1200,
  ADDITIONAL_SPORT_FEE: 500,

  // Image Constraints
  PROFILE_PHOTO_MAX_SIZE_KB: 1000,
  PAYMENT_SCREENSHOT_MAX_SIZE_KB: 500,

  // Building Options
  BUILDING_OPTIONS: [
    'Building 1',
    'Building 3',
    'Building 4',
    'Building 6',
    'Xxclusive',
    'Other',
  ] as const,

  // T-Shirt Sizes
  TSHIRT_SIZES: [
    '28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50',
  ] as const,

  // Gender Options
  GENDER_OPTIONS: ['Male', 'Female'] as const,

  // WhatsApp Links
  WHATSAPP_COMMUNITY_URL: 'https://chat.whatsapp.com/IklSdrxFlkM3dVbsWuVvLh',
  WHATSAPP_PICKLEBALL_URL: 'https://chat.whatsapp.com/EvLgSrLQp2DJLh67hEgNXu',

  // Coordinators
  COORDINATORS: [
    { building: 'Bldg 1', name: 'Krish Yadav', phone: '7400138377' },
    { building: 'Bldg 3', name: 'Amogh Bhatnagar', phone: '9969260690' },
    { building: 'Bldg 4', name: 'Archit Poddar', phone: '9166986357' },
    { building: 'Bldg 6', name: 'Priyanshi', phone: '8369961778' },
    { building: 'Xxclusive', name: 'Shantanu', phone: '7304489888' },
    { building: 'Others', name: 'Parag Jain', phone: '9769287124' },
  ] as const,

  // Sport Categories Order
  SPORT_CATEGORIES_ORDER: ['Cricket', 'Volleyball', 'Football', 'Pickleball', 'Badminton'] as const,
} as const
